document.documentElement.classList.remove('no-js');
const FRAGO_ORDER_KEY = 'frago_order_list_v1';
const FRAGO_ORDER_REFERENCE_KEY = 'frago_order_reference_v1';

function getFragoOrderReference() {
  let reference = sessionStorage.getItem(FRAGO_ORDER_REFERENCE_KEY);
  if (reference) return reference;
  const now = new Date();
  const date = now.getFullYear().toString() + String(now.getMonth() + 1).padStart(2, '0') + String(now.getDate()).padStart(2, '0');
  const token = Math.random().toString(36).slice(2, 7).toUpperCase();
  reference = 'FRAGO-' + date + '-' + token;
  sessionStorage.setItem(FRAGO_ORDER_REFERENCE_KEY, reference);
  return reference;
}

function readFragoOrderList() {
  try {
    const value = JSON.parse(localStorage.getItem(FRAGO_ORDER_KEY) || '[]');
    return Array.isArray(value) ? value : [];
  } catch (error) {
    return [];
  }
}

function saveFragoOrderList(items) {
  try {
    localStorage.setItem(FRAGO_ORDER_KEY, JSON.stringify(items));
    updateFragoOrderCount(items);
    return true;
  } catch (error) {
    return false;
  }
}

function updateFragoOrderCount(items) {
  const orderItems = items || readFragoOrderList();
  const count = orderItems.reduce(function (sum, item) { return sum + Math.max(1, Number(item.quantity) || 1); }, 0);
  document.querySelectorAll('[data-order-count]').forEach(function (badge) {
    badge.textContent = count;
    badge.closest('.order-list-link').classList.toggle('has-items', count > 0);
  });
}

function getSelectedOrderVariant(container) {
  const field = container.querySelector('[data-order-variant]');
  if (!field) return { id: '', title: '', priceCents: null, priceLabel: '' };
  const source = field.tagName === 'SELECT' ? field.options[field.selectedIndex] : field;
  const rawPrice = source.dataset.priceCents;
  return {
    id: field.value,
    title: source.dataset.variantTitle || source.textContent.trim(),
    priceCents: rawPrice === undefined || rawPrice === '' ? null : Number(rawPrice),
    priceLabel: source.dataset.priceLabel || ''
  };
}

function addProductToFragoOrder(button) {
  const container = button.closest('[data-order-product]');
  if (!container) return;
  const variant = getSelectedOrderVariant(container);
  const quantityField = container.querySelector('[data-order-quantity]');
  const quantity = Math.max(1, parseInt(quantityField && quantityField.value, 10) || 1);
  const item = {
    key: container.dataset.productUrl + '::' + variant.id,
    productTitle: container.dataset.productTitle || '',
    productUrl: container.dataset.productUrl || '',
    productImage: container.dataset.productImage || '',
    variantId: variant.id,
    variantTitle: variant.title || 'Standard',
    quantity: quantity,
    priceCents: Number.isFinite(variant.priceCents) ? variant.priceCents : null,
    priceLabel: variant.priceLabel || (container.dataset.priceMode === 'inquiry' ? 'Preis auf Anfrage' : '')
  };
  const items = readFragoOrderList();
  const existing = items.find(function (entry) { return entry.key === item.key; });
  if (existing) existing.quantity += quantity;
  else items.push(item);
  const saved = saveFragoOrderList(items);
  const feedback = container.querySelector('[data-order-feedback]');
  if (feedback) feedback.textContent = saved ? 'Zur Bestellliste hinzugefügt. Sie können weiter einkaufen oder die Bestellliste oben öffnen.' : 'Die Bestellliste konnte in diesem Browser nicht gespeichert werden.';
  if (saved) {
    if (document.querySelector('[data-order-items]')) renderFragoOrderList();
    button.classList.add('is-added');
    const original = button.textContent;
    button.textContent = '✓ Hinzugefügt';
    window.setTimeout(function () {
      button.textContent = original;
      button.classList.remove('is-added');
    }, 1800);
  }
}

function formatFragoMoney(cents, currency) {
  return new Intl.NumberFormat('de-AT', { style: 'currency', currency: currency || 'EUR' }).format((Number(cents) || 0) / 100);
}

function parseFragoEuroToCents(value, fallback) {
  const normalized = String(value == null ? '' : value).trim().replace(',', '.');
  const amount = Number(normalized);
  return Number.isFinite(amount) ? Math.round(amount * 100) : fallback;
}

function buildFragoOrderEmail(items, currency, canShowPrices, taxRate, discountRate, shippingThresholdCents, shippingFeeCents) {
  const lines = ['FRAGO BESTELLLISTE', ''];
  let netTotal = 0;
  items.forEach(function (item, index) {
    lines.push((index + 1) + '. ' + item.productTitle);
    lines.push('Variante: ' + (item.variantTitle || 'Standard'));
    lines.push('Menge: ' + item.quantity);
    if (canShowPrices && item.priceCents !== null) {
      const lineNet = item.priceCents * item.quantity;
      netTotal += lineNet;
      lines.push('Nettopreis: ' + formatFragoMoney(item.priceCents, currency));
      lines.push('Positionswert netto: ' + formatFragoMoney(lineNet, currency));
    }
    else lines.push('Preis: nach Kundenfreigabe / auf Anfrage');
    lines.push('Produktlink: ' + item.productUrl);
    lines.push('');
  });
  if (canShowPrices && netTotal > 0) {
    const rate = Number(taxRate) || 0;
    const discount = Math.round(netTotal * (Number(discountRate) || 0) / 100);
    const discountedNet = netTotal - discount;
    const shipping = discountedNet > 0 && discountedNet < shippingThresholdCents ? shippingFeeCents : 0;
    const taxableNet = discountedNet + shipping;
    const tax = Math.round(taxableNet * rate / 100);
    lines.push('Zwischensumme netto: ' + formatFragoMoney(netTotal, currency));
    if (discount > 0) lines.push('Kundenrabatt (' + discountRate + ' %): -' + formatFragoMoney(discount, currency));
    lines.push('Nettosumme nach Rabatt: ' + formatFragoMoney(discountedNet, currency));
    lines.push(shipping > 0 ? 'Versandkosten netto: ' + formatFragoMoney(shipping, currency) : 'Versandkosten: kostenlos');
    lines.push('Umsatzsteuer (' + rate + ' %): ' + formatFragoMoney(tax, currency));
    lines.push('Gesamtbetrag brutto: ' + formatFragoMoney(taxableNet + tax, currency));
    lines.push('');
  }
  return lines.join('\n');
}

function getFragoOrderRequestType(form) {
  const selected = form && form.querySelector('[data-order-request-option]:checked');
  return selected ? selected.value : 'Bestellung aufgeben';
}

function updateFragoOrderRequestType(form) {
  if (!form) return;
  const type = getFragoOrderRequestType(form);
  const typeField = form.querySelector('[data-order-request-type]');
  const subjectField = form.querySelector('[data-order-subject]');
  const referenceField = form.querySelector('[data-order-reference]');
  const reference = referenceField && referenceField.value ? referenceField.value : getFragoOrderReference();
  const submit = form.querySelector('[data-order-submit]');
  if (typeField) typeField.value = type;
  if (subjectField) subjectField.value = type === 'Angebot anfordern'
    ? 'Neue Angebotsanfrage ' + reference + ' über carwash.frago.at'
    : 'Neue Bestellung ' + reference + ' über carwash.frago.at';
  if (submit) submit.textContent = type === 'Angebot anfordern'
    ? 'Angebot anfordern →'
    : 'Bestellung abgeben →';
}

function buildFragoCompleteOrderEmail(form, items, currency, canShowPrices, taxRate, discountRate, shippingThresholdCents, shippingFeeCents) {
  const type = getFragoOrderRequestType(form);
  const reference = form.querySelector('[data-order-reference]')?.value || getFragoOrderReference();
  const lines = [
    'FRAGO ' + (type === 'Angebot anfordern' ? 'ANGEBOTSANFRAGE' : 'BESTELLUNG'),
    '',
    'FRAGO Bestellnummer: ' + reference,
    'Bestellart: ' + type,
    '',
    buildFragoOrderEmail(items, currency, canShowPrices, taxRate, discountRate, shippingThresholdCents, shippingFeeCents)
  ];
  return lines.join('\n');
}

function renderFragoOrderList() {
  const target = document.querySelector('[data-order-items]');
  if (!target) return;
  const items = readFragoOrderList();
  const empty = document.querySelector('[data-order-empty]');
  const total = document.querySelector('[data-order-total]');
  const shippingStatus = document.querySelector('[data-order-shipping-status]');
  const section = target.closest('[data-order-currency]');
  const currency = section ? section.dataset.orderCurrency : 'EUR';
  const canShowPrices = section && section.dataset.orderPriceAccess === 'true';
  const taxRate = section ? Number(section.dataset.orderTaxRate || 20) : 20;
  const discountRate = section ? Number(section.dataset.orderDiscount || 0) : 0;
  const shippingThresholdCents = parseFragoEuroToCents(section && section.dataset.orderShippingThreshold, 40000);
  const shippingFeeCents = parseFragoEuroToCents(section && section.dataset.orderShippingFee, 1290);
  target.replaceChildren();
  if (empty) empty.hidden = items.length > 0;

  let pricedTotal = 0;
  let hasInquiryPrice = false;
  items.forEach(function (item) {
    const row = document.createElement('article');
    row.className = 'order-list-item';

    const media = document.createElement('a');
    media.className = 'order-list-item-image';
    media.href = item.productUrl;
    if (item.productImage) {
      const image = document.createElement('img');
      image.src = item.productImage;
      image.alt = '';
      image.loading = 'lazy';
      media.appendChild(image);
    } else {
      media.textContent = 'FRAGO';
    }

    const copy = document.createElement('div');
    copy.className = 'order-list-item-copy';
    const title = document.createElement('h4');
    const titleLink = document.createElement('a');
    titleLink.href = item.productUrl;
    titleLink.textContent = item.productTitle;
    title.appendChild(titleLink);
    const variant = document.createElement('p');
    variant.textContent = item.variantTitle && item.variantTitle !== 'Default Title' ? item.variantTitle : 'Standardausführung';
    copy.append(title, variant);

    const quantity = document.createElement('label');
    quantity.className = 'order-list-quantity';
    quantity.appendChild(document.createTextNode('Menge'));
    const input = document.createElement('input');
    input.type = 'number';
    input.min = '1';
    input.step = '1';
    input.value = item.quantity;
    input.dataset.orderItemQuantity = item.key;
    quantity.appendChild(input);

    const price = document.createElement('div');
    price.className = 'order-list-item-price';
    if (canShowPrices && item.priceCents !== null) {
      pricedTotal += item.priceCents * item.quantity;
      price.textContent = formatFragoMoney(item.priceCents * item.quantity, currency) + ' netto';
    } else {
      hasInquiryPrice = true;
      price.textContent = 'Preis nach Kundenfreigabe';
    }

    const remove = document.createElement('button');
    remove.className = 'order-list-remove';
    remove.type = 'button';
    remove.dataset.orderRemove = item.key;
    remove.setAttribute('aria-label', item.productTitle + ' entfernen');
    remove.textContent = 'Entfernen';
    row.append(media, copy, quantity, price, remove);
    target.appendChild(row);
  });

  if (total) {
    total.hidden = items.length === 0;
    if (canShowPrices && pricedTotal > 0) {
      const discount = Math.round(pricedTotal * discountRate / 100);
      const discountedNet = pricedTotal - discount;
      const shipping = discountedNet > 0 && discountedNet < shippingThresholdCents ? shippingFeeCents : 0;
      const taxableNet = discountedNet + shipping;
      const tax = Math.round(taxableNet * taxRate / 100);
      total.innerHTML = '<span>Zwischensumme netto <b>' + formatFragoMoney(pricedTotal, currency) + '</b></span>' +
        (discount > 0 ? '<span class="order-discount">Kundenrabatt (' + discountRate + ' %) <b>−' + formatFragoMoney(discount, currency) + '</b></span>' : '') +
        '<span>Nettosumme nach Rabatt <b>' + formatFragoMoney(discountedNet, currency) + '</b></span>' +
        '<span>Versandkosten netto <b>' + (shipping > 0 ? formatFragoMoney(shipping, currency) : 'kostenlos') + '</b></span>' +
        '<span>Umsatzsteuer (' + taxRate + ' %) <b>' + formatFragoMoney(tax, currency) + '</b></span>' +
        '<strong>Gesamtbetrag brutto <b>' + formatFragoMoney(taxableNet + tax, currency) + '</b></strong>' +
        (hasInquiryPrice ? '<small>Weitere Positionen sind auf Anfrage.</small>' : '');
    } else {
      total.textContent = items.length ? 'Preise werden nach Freigabe Ihres Kundenkontos angezeigt und von FRAGO bestätigt.' : '';
    }
  }
  if (shippingStatus) {
    if (canShowPrices && pricedTotal > 0) {
      const discount = Math.round(pricedTotal * discountRate / 100);
      const discountedNet = pricedTotal - discount;
      if (discountedNet < shippingThresholdCents) {
        shippingStatus.textContent = 'Noch ' + formatFragoMoney(shippingThresholdCents - discountedNet, currency) + ' netto bis zum kostenlosen Versand. Aktuelle Versandkosten: ' + formatFragoMoney(shippingFeeCents, currency) + ' netto.';
      } else {
        shippingStatus.textContent = 'Versandkostenfrei – die Nettoversandgrenze ist erreicht.';
      }
    } else if (canShowPrices) {
      shippingStatus.textContent = 'Fügen Sie Produkte hinzu, um den verbleibenden Betrag bis zum kostenlosen Versand zu sehen.';
    } else {
      shippingStatus.textContent = 'Ohne Preisfreigabe werden Versandkosten und Konditionen von FRAGO mit der Bestätigung mitgeteilt.';
    }
  }
  const emailField = document.querySelector('[data-order-email]');
  if (emailField) emailField.value = buildFragoOrderEmail(items, currency, canShowPrices, taxRate, discountRate, shippingThresholdCents, shippingFeeCents);
}

document.addEventListener('click', function (event) {
  const productBack = event.target.closest('[data-product-back]');
  if (productBack) {
    const referrer = document.referrer;
    let sameShopReferrer = false;
    try { sameShopReferrer = Boolean(referrer) && new URL(referrer).origin === window.location.origin; } catch (error) { sameShopReferrer = false; }
    if (sameShopReferrer && window.history.length > 1) window.history.back();
    else window.location.href = productBack.dataset.fallbackUrl || '/collections/all';
    return;
  }
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const nav = document.querySelector('[data-mobile-menu]');
    const open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
    document.body.classList.toggle('mobile-menu-open', open);
  }
  const submenuToggle = event.target.closest('[data-mobile-submenu-toggle]');
  if (submenuToggle) {
    const group = submenuToggle.closest('.mobile-menu-group');
    const submenu = group && group.querySelector('[data-mobile-submenu]');
    const open = submenuToggle.getAttribute('aria-expanded') !== 'true';
    submenuToggle.setAttribute('aria-expanded', String(open));
    submenuToggle.textContent = open ? '−' : '+';
    if (submenu) submenu.hidden = !open;
  }
  const add = event.target.closest('[data-ajax-add]');
  if (add) add.classList.add('is-loading');
  const orderAdd = event.target.closest('[data-order-add]');
  if (orderAdd) addProductToFragoOrder(orderAdd);
  const remove = event.target.closest('[data-order-remove]');
  if (remove) {
    const items = readFragoOrderList().filter(function (item) { return item.key !== remove.dataset.orderRemove; });
    saveFragoOrderList(items);
    renderFragoOrderList();
  }
  const guest = event.target.closest('[data-order-guest]');
  if (guest) {
    const form = document.querySelector('[data-order-customer-form]');
    if (form) {
      form.classList.add('is-active');
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const firstField = form.querySelector('input:not([type="hidden"])');
      if (firstField) window.setTimeout(function () { firstField.focus(); }, 450);
    }
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  const nav = document.querySelector('[data-mobile-menu]');
  const toggle = document.querySelector('[data-menu-toggle]');
  if (nav && nav.classList.contains('is-open')) {
    nav.classList.remove('is-open');
    document.body.classList.remove('mobile-menu-open');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Menü öffnen');
      toggle.focus();
    }
  }
});

document.addEventListener('change', function (event) {
  const requestOption = event.target.closest('[data-order-request-option]');
  if (requestOption) updateFragoOrderRequestType(requestOption.form);
  const select = event.target.closest('select[data-order-variant]');
  if (select) {
    const panel = select.closest('[data-order-product]');
    const links = panel && panel.querySelectorAll('[data-inquiry-link]');
    const selected = select.options[select.selectedIndex];
    if (links) links.forEach(function (link) {
      const params = new URLSearchParams();
      params.set('anfrageart', link.dataset.inquiryType || 'Produktanfrage');
      params.set('produkt', link.dataset.productTitle || '');
      params.set('variante', selected.dataset.variantTitle || selected.textContent.trim());
      params.set('produkt_url', link.dataset.productUrl || '');
      link.href = '/pages/kontakt?' + params.toString() + '#anfrageformular';
    });
  }
  const priceSelect = event.target.closest('[data-product-price-select]');
  if (priceSelect) {
    const selected = priceSelect.options[priceSelect.selectedIndex];
    const price = document.querySelector('[data-product-price]');
    if (price && selected.dataset.priceLabel) price.textContent = selected.dataset.priceLabel;
  }
  const orderQuantity = event.target.closest('[data-order-item-quantity]');
  if (orderQuantity) {
    const items = readFragoOrderList();
    const item = items.find(function (entry) { return entry.key === orderQuantity.dataset.orderItemQuantity; });
    if (item) {
      item.quantity = Math.max(1, parseInt(orderQuantity.value, 10) || 1);
      saveFragoOrderList(items);
      renderFragoOrderList();
    }
  }
});

document.addEventListener('submit', function (event) {
  const form = event.target.closest('#FragoOrderForm');
  if (!form) return;
  const items = readFragoOrderList();
  if (!items.length) {
    event.preventDefault();
    const empty = document.querySelector('[data-order-empty]');
    if (empty) empty.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.alert('Bitte fügen Sie mindestens ein Produkt zur Bestellliste hinzu.');
    return;
  }
  const section = form.closest('[data-order-currency]');
  const canShowPrices = section && section.dataset.orderPriceAccess === 'true';
  const emailField = form.querySelector('[data-order-email]');
  const fullEmailField = form.querySelector('[data-order-full-email]');
  const currency = section ? section.dataset.orderCurrency : 'EUR';
  const taxRate = section ? Number(section.dataset.orderTaxRate || 20) : 20;
  const discountRate = section ? Number(section.dataset.orderDiscount || 0) : 0;
  const shippingThresholdCents = parseFragoEuroToCents(section && section.dataset.orderShippingThreshold, 40000);
  const shippingFeeCents = parseFragoEuroToCents(section && section.dataset.orderShippingFee, 1290);
  const referenceField = form.querySelector('[data-order-reference]');
  if (referenceField) referenceField.value = getFragoOrderReference();
  updateFragoOrderRequestType(form);
  if (emailField) emailField.value = buildFragoOrderEmail(items, currency, canShowPrices, taxRate, discountRate, shippingThresholdCents, shippingFeeCents);
  if (fullEmailField) fullEmailField.value = buildFragoCompleteOrderEmail(form, items, currency, canShowPrices, taxRate, discountRate, shippingThresholdCents, shippingFeeCents);
});

document.addEventListener('DOMContentLoaded', function () {
  updateFragoOrderRequestType(document.querySelector('#FragoOrderForm'));
  const orderReferenceField = document.querySelector('[data-order-reference]');
  if (orderReferenceField) orderReferenceField.value = getFragoOrderReference();
  document.querySelectorAll('select[data-default]').forEach(function (select) {
    if (select.dataset.default) select.value = select.dataset.default;
  });
  document.querySelectorAll('.popular-row').forEach(function (row) {
    const track = row.querySelector('[data-product-row-track]');
    const previous = row.querySelector('[data-product-row-prev]');
    const next = row.querySelector('[data-product-row-next]');
    if (!track || !previous || !next) return;
    function move(direction) {
      const card = track.querySelector('.popular-product-card');
      const distance = window.matchMedia('(max-width: 767px)').matches
        ? track.clientWidth
        : (card ? card.getBoundingClientRect().width + 2 : track.clientWidth);
      track.scrollBy({ left: direction * distance, behavior: 'smooth' });
    }
    previous.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    let touchStartX = 0;
    let touchStartY = 0;
    let productRowDragged = false;
    track.addEventListener('touchstart', function (event) {
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      productRowDragged = false;
    }, { passive: true });
    track.addEventListener('touchmove', function (event) {
      const deltaX = Math.abs(event.touches[0].clientX - touchStartX);
      const deltaY = Math.abs(event.touches[0].clientY - touchStartY);
      if (deltaX > 9 && deltaX > deltaY) productRowDragged = true;
    }, { passive: true });
    track.addEventListener('click', function (event) {
      if (!productRowDragged) return;
      event.preventDefault();
      event.stopPropagation();
      productRowDragged = false;
    }, true);
  });
  document.querySelectorAll('.business-area-grid,.wash-category-grid,.main-area-overview .overview-grid').forEach(function (grid) {
    let gridTouchX = 0;
    let gridTouchY = 0;
    let gridDragged = false;
    grid.addEventListener('touchstart', function (event) {
      gridTouchX = event.touches[0].clientX;
      gridTouchY = event.touches[0].clientY;
      gridDragged = false;
    }, { passive: true });
    grid.addEventListener('touchmove', function (event) {
      const deltaX = Math.abs(event.touches[0].clientX - gridTouchX);
      const deltaY = Math.abs(event.touches[0].clientY - gridTouchY);
      if (deltaX > 9 && deltaX > deltaY) gridDragged = true;
    }, { passive: true });
    grid.addEventListener('click', function (event) {
      if (!gridDragged) return;
      event.preventDefault();
      event.stopPropagation();
      gridDragged = false;
    }, true);
  });
  document.querySelectorAll('[data-nav-dropdown]').forEach(function (dropdown) {
    const previews = dropdown.querySelectorAll('[data-nav-preview-item]');
    const links = dropdown.querySelectorAll('[data-nav-preview-index]');
    function showPreview(index) {
      previews.forEach(function (preview) {
        preview.classList.toggle('is-active', preview.dataset.navPreviewItem === String(index));
      });
    }
    links.forEach(function (link) {
      link.addEventListener('mouseenter', function () { showPreview(link.dataset.navPreviewIndex); });
      link.addEventListener('focus', function () { showPreview(link.dataset.navPreviewIndex); });
    });
    dropdown.addEventListener('mouseleave', function () { showPreview(0); });
    dropdown.addEventListener('focusout', function (event) {
      if (!dropdown.contains(event.relatedTarget)) showPreview(0);
    });
  });
  updateFragoOrderCount();
  if (document.querySelector('[data-order-success]')) {
    const successReference = document.querySelector('[data-order-success-reference]');
    if (successReference) successReference.textContent = sessionStorage.getItem(FRAGO_ORDER_REFERENCE_KEY) || 'wird mit der Bestätigung übermittelt';
    saveFragoOrderList([]);
    sessionStorage.removeItem(FRAGO_ORDER_REFERENCE_KEY);
  }
  renderFragoOrderList();
  const params = new URLSearchParams(window.location.search);
  document.querySelectorAll('[data-query-field]').forEach(function (field) {
    let value = params.get(field.dataset.queryField);
    if (value && field.matches('[data-area-select]')) {
      const area = value.toLowerCase();
      if (area.includes('lkw') || area.includes('nufa') || area.includes('nutzfahrzeug')) value = 'Lkw-Betrieb';
      else if (area.includes('auto') || area.includes('aussen') || area.includes('außen') || area.includes('innen') || area.includes('lack') || area.includes('geraet') || area.includes('gerät')) value = 'Autohaus / Autoaufbereitung';
      else if (area.includes('service') || area.includes('beratung')) value = 'Service / Beratung';
      else if (area.includes('wasch') || area.includes('portal') || area.includes('sb') || area.includes('spezial')) value = 'Waschanlage';
      else value = 'Sonstiges';
    }
    if (value && !field.value) {
      field.value = value;
      const queryField = field.closest('.query-only-field');
      if (queryField) queryField.classList.add('is-filled');
    }
  });
  const inquiryType = params.get('anfrageart') || 'Produktanfrage';
  const productName = params.get('produkt');
  const productVariant = params.get('variante');
  const subject = document.querySelector('[data-query-field="betreff"]');
  if (subject && !subject.value && productName) subject.value = inquiryType + ': ' + productName;
  const message = document.querySelector('[data-inquiry-message]');
  if (message && !message.value && productName) {
    message.value = inquiryType === 'Bestellanfrage'
      ? 'Ich möchte folgendes Produkt bestellen und bitte um ein Angebot bzw. die weitere Bestellabwicklung:\\n\\n' + productName + (productVariant ? ' – ' + productVariant : '')
      : 'Ich wünsche eine Beratung bzw. ein Angebot zu folgendem Produkt:\\n\\n' + productName + (productVariant ? ' – ' + productVariant : '');
  }

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = gallery.querySelectorAll('[data-gallery-slide]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    const current = gallery.querySelector('[data-gallery-current]');
    let index = 0;
    if (!track || slides.length < 2) return;
    function goTo(next) {
      index = (next + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (current) current.textContent = index + 1;
    }
    gallery.querySelector('[data-gallery-prev]').addEventListener('click', function () { goTo(index - 1); });
    gallery.querySelector('[data-gallery-next]').addEventListener('click', function () { goTo(index + 1); });
    thumbs.forEach(function (thumb) { thumb.addEventListener('click', function () { goTo(Number(thumb.dataset.index)); }); });
    let startX = 0;
    track.addEventListener('touchstart', function (event) { startX = event.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (event) {
      const distance = event.changedTouches[0].clientX - startX;
      if (Math.abs(distance) > 45) goTo(index + (distance < 0 ? 1 : -1));
    }, { passive: true });
    goTo(0);
  });
});
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-product-information-tabs]').forEach(function (component) {
    const tabs = Array.from(component.querySelectorAll('[data-product-information-tab]'));
    const panels = Array.from(component.querySelectorAll('[data-product-information-panel]'));
    function activate(name, focusTab) {
      tabs.forEach(function (tab) {
        const active = tab.dataset.productInformationTab === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.setAttribute('tabindex', active ? '0' : '-1');
        if (active && focusTab) tab.focus();
      });
      panels.forEach(function (panel) {
        const active = panel.dataset.productInformationPanel === name;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { activate(tab.dataset.productInformationTab, false); });
      tab.addEventListener('keydown', function (event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        activate(tabs[next].dataset.productInformationTab, true);
      });
    });
    if (tabs.length) activate(tabs[0].dataset.productInformationTab, false);
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const overlay = document.querySelector('[data-search-overlay]');
  if (!overlay) return;
  const input = overlay.querySelector('[data-search-input]');
  const suggestions = overlay.querySelector('[data-search-suggestions]');
  const openers = document.querySelectorAll('[data-search-open]');
  const closers = overlay.querySelectorAll('[data-search-close]');
  let searchTimer;
  function openSearch() { overlay.hidden = false; document.body.classList.add('search-is-open'); openers.forEach(b => b.setAttribute('aria-expanded', 'true')); window.setTimeout(() => input && input.focus(), 30); }
  function closeSearch() { overlay.hidden = true; document.body.classList.remove('search-is-open'); openers.forEach(b => b.setAttribute('aria-expanded', 'false')); }
  openers.forEach(button => button.addEventListener('click', openSearch));
  closers.forEach(button => button.addEventListener('click', closeSearch));
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && !overlay.hidden) closeSearch(); });
  function renderSuggestions(items, query) {
    suggestions.replaceChildren();
    if (!items.length) { const p = document.createElement('p'); p.textContent = 'Keine direkten Treffer. Mit Enter alle Ergebnisse für „' + query + '“ anzeigen.'; suggestions.appendChild(p); return; }
    const grid = document.createElement('div'); grid.className = 'frago-search-suggestion-grid';
    items.forEach(item => {
      const a = document.createElement('a'); a.href = item.url; a.className = 'frago-search-suggestion';
      const media = document.createElement('span'); media.className = 'frago-search-suggestion-image';
      if (item.image) { const img = document.createElement('img'); img.src = item.image; img.alt = ''; media.appendChild(img); } else { media.textContent = 'FRAGO'; }
      const copy = document.createElement('span'); const small = document.createElement('small'); small.textContent = item.type === 'product' ? 'Produkt' : 'Information'; const strong = document.createElement('strong'); strong.textContent = item.title; copy.append(small, strong); a.append(media, copy); grid.appendChild(a);
    });
    suggestions.appendChild(grid);
  }
  if (input) input.addEventListener('input', function () {
    window.clearTimeout(searchTimer); const query = input.value.trim();
    if (query.length < 2) { suggestions.innerHTML = '<p>Geben Sie mindestens zwei Zeichen ein. Wir durchsuchen Produkte und Informationsseiten.</p>'; return; }
    suggestions.innerHTML = '<p>Suche läuft …</p>';
    searchTimer = window.setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,page&resources[limit]=6')
        .then(response => response.ok ? response.json() : Promise.reject())
        .then(data => { const results = data.resources && data.resources.results ? data.resources.results : {}; const items = [].concat(results.products || [], results.pages || []).slice(0, 6); renderSuggestions(items, query); })
        .catch(() => { suggestions.innerHTML = '<p>Vorschläge konnten nicht geladen werden. Drücken Sie Enter, um die Suche zu starten.</p>'; });
    }, 220);
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const picker = document.querySelector('[data-order-product-picker]');
  if (!picker) return;
  const input = picker.querySelector('[data-order-product-search]');
  const results = picker.querySelector('[data-order-product-results]');
  const selection = picker.querySelector('[data-order-product-selection]');
  const priceAccess = picker.closest('[data-order-price-access]')?.dataset.orderPriceAccess === 'true';
  let timer;
  function productJsonUrl(url) {
    const clean = String(url || '').split('?')[0].replace(/\/$/, '');
    return clean.endsWith('.js') ? clean : clean + '.js';
  }
  function showSelectedProduct(product, originalUrl) {
    selection.replaceChildren();
    selection.hidden = false;
    selection.dataset.orderProduct = '';
    selection.dataset.productTitle = product.title || '';
    selection.dataset.productUrl = originalUrl || product.url || '';
    selection.dataset.productImage = product.featured_image || (product.images && product.images[0]) || '';
    selection.dataset.priceMode = priceAccess ? 'priced' : 'inquiry';
    const media = document.createElement('span'); media.className = 'order-picker-selected-image';
    if (selection.dataset.productImage) { const image = document.createElement('img'); image.src = selection.dataset.productImage; image.alt = ''; media.appendChild(image); } else media.textContent = 'FRAGO';
    const copy = document.createElement('div'); copy.className = 'order-picker-selected-copy';
    const label = document.createElement('small'); label.textContent = 'Ausgewähltes Produkt';
    const title = document.createElement('h4'); title.textContent = product.title || '';
    const fields = document.createElement('div'); fields.className = 'order-picker-fields';
    const variantLabel = document.createElement('label'); variantLabel.textContent = 'Variante';
    const select = document.createElement('select'); select.dataset.orderVariant = '';
    (product.variants || []).forEach(function (variant) {
      const option = document.createElement('option'); option.value = variant.id; option.textContent = (variant.title || 'Standard') + (priceAccess && variant.price != null ? ' – ' + formatFragoMoney(variant.price, document.querySelector('[data-order-currency]')?.dataset.orderCurrency || 'EUR') + ' netto' : ''); option.disabled = variant.available === false; option.dataset.variantTitle = variant.title || 'Standard'; option.dataset.priceCents = priceAccess && variant.price != null ? variant.price : ''; option.dataset.priceLabel = priceAccess && variant.price != null ? formatFragoMoney(variant.price, document.querySelector('[data-order-currency]')?.dataset.orderCurrency || 'EUR') + ' netto' : 'Preis nach Kundenfreigabe'; select.appendChild(option);
    });
    variantLabel.appendChild(select);
    const quantityLabel = document.createElement('label'); quantityLabel.textContent = 'Menge'; const quantity = document.createElement('input'); quantity.type = 'number'; quantity.min = '1'; quantity.step = '1'; quantity.value = '1'; quantity.dataset.orderQuantity = ''; quantityLabel.appendChild(quantity);
    fields.append(variantLabel, quantityLabel);
    const actions = document.createElement('div'); actions.className = 'order-picker-actions';
    const add = document.createElement('button'); add.type = 'button'; add.className = 'btn'; add.dataset.orderAdd = ''; add.textContent = 'Zur Bestellliste hinzufügen →';
    const change = document.createElement('button'); change.type = 'button'; change.className = 'order-picker-change'; change.textContent = 'Anderes Produkt suchen'; change.addEventListener('click', function () { selection.hidden = true; selection.replaceChildren(); input.focus(); });
    const feedback = document.createElement('p'); feedback.className = 'order-add-feedback'; feedback.dataset.orderFeedback = ''; feedback.setAttribute('role', 'status');
    actions.append(add, change); copy.append(label, title, fields, actions, feedback); selection.append(media, copy);
  }
  function selectProduct(url) {
    selection.hidden = false; selection.innerHTML = '<p class="order-picker-loading">Produktdaten werden geladen …</p>';
    fetch(productJsonUrl(url)).then(response => response.ok ? response.json() : Promise.reject()).then(product => showSelectedProduct(product, url)).catch(function () { selection.innerHTML = '<p class="order-picker-error">Das Produkt konnte nicht geladen werden. Bitte öffnen Sie die Produktseite und fügen Sie es dort hinzu.</p>'; });
  }
  function renderProducts(products) {
    results.replaceChildren();
    if (!products.length) { results.innerHTML = '<p>Keine Produkte gefunden. Versuchen Sie einen anderen Suchbegriff.</p>'; return; }
    const grid = document.createElement('div'); grid.className = 'order-product-result-grid';
    products.forEach(function (product) {
      const button = document.createElement('button'); button.type = 'button'; button.className = 'order-product-result';
      const media = document.createElement('span'); media.className = 'order-product-result-image';
      if (product.image) { const image = document.createElement('img'); image.src = typeof product.image === 'string' ? product.image : product.image.url; image.alt = ''; media.appendChild(image); } else media.textContent = 'FRAGO';
      const copy = document.createElement('span'); copy.className = 'order-product-result-copy'; const strong = document.createElement('strong'); strong.textContent = product.title; const action = document.createElement('b'); action.textContent = 'Auswählen →'; copy.append(strong, action); button.append(media, copy); button.addEventListener('click', function () { selectProduct(product.url); }); grid.appendChild(button);
    });
    results.appendChild(grid);
  }
  input.addEventListener('input', function () {
    clearTimeout(timer); const query = input.value.trim();
    if (query.length < 2) { results.innerHTML = '<p>Mindestens zwei Zeichen eingeben.</p>'; return; }
    results.innerHTML = '<p>Produkte werden gesucht …</p>';
    timer = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8')
        .then(response => response.ok ? response.json() : Promise.reject())
        .then(data => renderProducts(data.resources?.results?.products || []))
        .catch(() => { results.innerHTML = '<p>Die Produktsuche konnte nicht geladen werden. Bitte versuchen Sie es erneut.</p>'; });
    }, 220);
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const banner = document.querySelector('[data-cookie-consent]');
  if (!banner || !window.Shopify || typeof Shopify.loadFeatures !== 'function') return;
  const localConsentKey = 'frago_cookie_consent_v1';
  const settings = banner.querySelector('[data-cookie-settings]');
  const customize = banner.querySelector('[data-cookie-customize]');
  const save = banner.querySelector('[data-cookie-save]');
  const analytics = banner.querySelector('[data-cookie-analytics]');
  const preferences = banner.querySelector('[data-cookie-preferences]');
  const marketing = banner.querySelector('[data-cookie-marketing]');
  const reopen = document.querySelector('[data-cookie-reopen]');
  function showBanner(showSettings) {
    banner.hidden = false;
    document.body.classList.add('cookie-consent-open');
    settings.hidden = !showSettings;
    save.hidden = !showSettings;
    customize.hidden = showSettings;
  }
  function hideBanner() { banner.hidden = true; document.body.classList.remove('cookie-consent-open'); }
  Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
    const privacy = Shopify.customerPrivacy;
    if (!privacy) return;
    if (privacy.currentVisitorConsent) {
      const current = privacy.currentVisitorConsent();
      analytics.checked = current.analytics === 'yes';
      preferences.checked = current.preferences === 'yes';
      marketing.checked = current.marketing === 'yes';
    }
    let locallyDecided = false;
    try { locallyDecided = localStorage.getItem(localConsentKey) === 'saved'; } catch (error) {}
    if (!locallyDecided && privacy.shouldShowBanner && privacy.shouldShowBanner()) showBanner(false);
    function setConsent(options) {
      try { localStorage.setItem(localConsentKey, 'saved'); } catch (error) {}
      hideBanner();
      privacy.setTrackingConsent(options, function () {});
    }
    banner.querySelector('[data-cookie-accept]').addEventListener('click', function () { setConsent({ analytics: true, preferences: true, marketing: true, sale_of_data: false }); });
    banner.querySelector('[data-cookie-essential]').addEventListener('click', function () { setConsent({ analytics: false, preferences: false, marketing: false, sale_of_data: false }); });
    save.addEventListener('click', function () { setConsent({ analytics: analytics.checked, preferences: preferences.checked, marketing: marketing.checked, sale_of_data: false }); });
    customize.addEventListener('click', function () { showBanner(true); });
    if (reopen) reopen.addEventListener('click', function () { showBanner(true); });
  });
});
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collection-page .next a, .search-results-page .next a, .knowledge-page .next a').forEach(function (link) { link.textContent = 'Weiter →'; link.setAttribute('aria-label', 'Nächste Seite'); });
  document.querySelectorAll('.collection-page .prev a, .search-results-page .prev a, .knowledge-page .prev a').forEach(function (link) { link.textContent = '← Zurück'; link.setAttribute('aria-label', 'Vorherige Seite'); });
});
document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('[data-alternate-address-toggle]');
  const panel = document.querySelector('[data-alternate-address]');
  if (!toggle || !panel) return;
  function updateAlternateAddress() {
    const active = toggle.checked;
    panel.hidden = !active;
    panel.querySelectorAll('[data-alternate-address-field]').forEach(function (field) { field.disabled = !active; });
    panel.querySelectorAll('[data-alternate-required]').forEach(function (field) { field.required = active; });
  }
  toggle.addEventListener('change', updateAlternateAddress);
  updateAlternateAddress();
});
